import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DisplayTab } from '../../mapping/entity-display.model';
import { DraftFieldValueComponent } from '../draft-field-value/draft-field-value.component';

/**
 * One tab: its label over a read-only table of the entity's rows, such as a test's steps. Library-local: the design
 * system has no simple read-only table, and `common-grid` is too heavy inside a panel.
 */
@Component({
    standalone: true,
    selector: 'p-ai-chat-draft-table',
    imports: [TranslateModule, DraftFieldValueComponent],
    templateUrl: './draft-table.component.html',
    styleUrl: './draft-table.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DraftTableComponent {
    public readonly tab = input.required<DisplayTab>();
}
